import React, { useState } from 'react';
import { layananData as initialData } from '../data/adminData';
import { FaPlus, FaEdit, FaTrash, FaSearch, FaSave, FaTimes, FaToggleOn, FaToggleOff } from 'react-icons/fa';

const KelolaLayanan = () => {
    const [layanan, setLayanan] = useState(initialData);
    const [searchTerm, setSearchTerm] = useState('');
    const [showForm, setShowForm] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [formData, setFormData] = useState({
        nama: '', kategori: 'retribusi', status: 'active',
        deskripsi: '', icon: '', link: '', tarif: '',
        persyaratan: '', prosedur: ''
    });

    const filteredLayanan = layanan.filter(item =>
        item.nama.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleSubmit = (e) => {
        e.preventDefault();
        const newData = {
            ...formData,
            persyaratan: formData.persyaratan.split('\n').filter(p => p.trim()),
            prosedur: formData.prosedur.split('\n').filter(p => p.trim())
        };

        if (editingId) {
            setLayanan(prev => prev.map(item =>
                item.id === editingId ? { ...newData, id: editingId } : item
            ));
        } else {
            setLayanan(prev => [...prev, { ...newData, id: Date.now() }]);
        }
        setShowForm(false);
        setEditingId(null);
        setFormData({ nama: '', kategori: 'retribusi', status: 'active', deskripsi: '', icon: '', link: '', tarif: '', persyaratan: '', prosedur: '' });
    };

    const handleEdit = (item) => {
        setFormData({
            ...item,
            persyaratan: item.persyaratan.join('\n'),
            prosedur: item.prosedur.join('\n')
        });
        setEditingId(item.id);
        setShowForm(true);
    };

    const toggleStatus = (id) => {
        setLayanan(prev => prev.map(item =>
            item.id === id ? { ...item, status: item.status === 'active' ? 'inactive' : 'active' } : item
        ));
    };

    const handleDelete = (id) => {
        if (window.confirm('Yakin ingin menghapus layanan ini?')) {
            setLayanan(prev => prev.filter(item => item.id !== id));
        }
    };

    return (
        <div>
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-[#0F172A]">Kelola Layanan</h2>
                <button
                    onClick={() => { setShowForm(true); setEditingId(null); setFormData({ nama: '', kategori: 'retribusi', status: 'active', deskripsi: '', icon: '', link: '', tarif: '', persyaratan: '', prosedur: '' }); }}
                    className="btn-primary flex items-center"
                >
                    <FaPlus className="mr-2" /> Tambah Layanan
                </button>
            </div>

            {/* Search */}
            <div className="bg-white rounded-xl p-4 shadow-sm mb-6">
                <div className="relative">
                    <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                    <input
                        type="text"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        placeholder="Cari layanan..."
                        className="w-full pl-10 pr-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488]"
                    />
                </div>
            </div>

            {/* Form Modal */}
            {showForm && (
                <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                        <div className="p-6">
                            <div className="flex justify-between items-center mb-6">
                                <h3 className="text-xl font-bold text-[#0F172A]">
                                    {editingId ? 'Edit Layanan' : 'Tambah Layanan Baru'}
                                </h3>
                                <button onClick={() => setShowForm(false)} className="text-gray-500 hover:text-gray-700">
                                    <FaTimes />
                                </button>
                            </div>
                            <form onSubmit={handleSubmit} className="space-y-4">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Nama Layanan *</label>
                                        <input type="text" value={formData.nama} onChange={(e) => setFormData({ ...formData, nama: e.target.value })}
                                            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488]" required />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Kategori</label>
                                        <select value={formData.kategori} onChange={(e) => setFormData({ ...formData, kategori: e.target.value })}
                                            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488]">
                                            <option value="retribusi">Retribusi</option>
                                            <option value="sewa">Sewa</option>
                                            <option value="perizinan">Perizinan</option>
                                            <option value="administrasi">Administrasi</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
                                        <select value={formData.status} onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                                            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488]">
                                            <option value="active">Aktif</option>
                                            <option value="inactive">Nonaktif</option>
                                        </select>
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Icon (Emoji)</label>
                                        <input type="text" value={formData.icon} onChange={(e) => setFormData({ ...formData, icon: e.target.value })}
                                            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488]" placeholder="📄" />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Link</label>
                                        <input type="text" value={formData.link} onChange={(e) => setFormData({ ...formData, link: e.target.value })}
                                            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488]" />
                                    </div>
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Tarif</label>
                                        <input type="text" value={formData.tarif} onChange={(e) => setFormData({ ...formData, tarif: e.target.value })}
                                            className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488]" />
                                    </div>
                                    <div className="md:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Deskripsi</label>
                                        <textarea value={formData.deskripsi} onChange={(e) => setFormData({ ...formData, deskripsi: e.target.value })}
                                            rows="2" className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488]" />
                                    </div>
                                    <div className="md:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Persyaratan (satu per baris)</label>
                                        <textarea value={formData.persyaratan} onChange={(e) => setFormData({ ...formData, persyaratan: e.target.value })}
                                            rows="4" className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488]" />
                                    </div>
                                    <div className="md:col-span-2">
                                        <label className="block text-sm font-medium text-gray-700 mb-1">Prosedur (satu per baris)</label>
                                        <textarea value={formData.prosedur} onChange={(e) => setFormData({ ...formData, prosedur: e.target.value })}
                                            rows="4" className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-[#0D9488]" />
                                    </div>
                                </div>
                                <div className="flex justify-end space-x-3">
                                    <button type="button" onClick={() => setShowForm(false)} className="px-6 py-2 border rounded-lg text-gray-700 hover:bg-gray-50">
                                        Batal
                                    </button>
                                    <button type="submit" className="btn-primary flex items-center">
                                        <FaSave className="mr-2" /> Simpan
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Table */}
            <div className="bg-white rounded-xl shadow-sm overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full">
                        <thead className="bg-gray-50">
                            <tr className="text-left text-sm text-gray-500">
                                <th className="p-4">Layanan</th>
                                <th className="p-4">Kategori</th>
                                <th className="p-4">Status</th>
                                <th className="p-4">Tarif</th>
                                <th className="p-4">Aksi</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredLayanan.map((item) => (
                                <tr key={item.id} className="border-b hover:bg-gray-50">
                                    <td className="p-4">
                                        <div className="flex items-center">
                                            <span className="text-2xl mr-3">{item.icon}</span>
                                            <div>
                                                <p className="font-medium text-gray-700">{item.nama}</p>
                                                <p className="text-xs text-gray-500">{item.deskripsi?.substring(0, 50)}...</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="p-4">
                                        <span className="bg-blue-50 text-blue-600 text-xs px-2 py-1 rounded-full capitalize">
                                            {item.kategori}
                                        </span>
                                    </td>
                                    <td className="p-4">
                                        <button onClick={() => toggleStatus(item.id)} className="text-2xl">
                                            {item.status === 'active' ? (
                                                <FaToggleOn className="text-green-500" />
                                            ) : (
                                                <FaToggleOff className="text-gray-400" />
                                            )}
                                        </button>
                                    </td>
                                    <td className="p-4 text-sm text-gray-500">{item.tarif}</td>
                                    <td className="p-4">
                                        <div className="flex space-x-2">
                                            <button onClick={() => handleEdit(item)} className="text-blue-500 hover:text-blue-700 p-1">
                                                <FaEdit />
                                            </button>
                                            <button onClick={() => handleDelete(item.id)} className="text-red-500 hover:text-red-700 p-1">
                                                <FaTrash />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default KelolaLayanan;